import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";
import {
  VOID_CONFIRM_MESSAGE,
  VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_146_manual_journals: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "29",
    },
    title: "Manual journals",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "voucher_no",
            Name: "journal_voucher_summary",
            BindValue: "grid_journal_voucher",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/journal_voucher/<id>",
                },
                ActionType: ActionType.VIEW,
                ScreenId: "29",
                tooltip: "View",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/journal_voucher/<id>",
                },
                ActionType: "Edit",
                ScreenId: "29",
                hiddenWhenVoid: true,
              },
                            {
                ActionType: ActionType.VOID,
                permissionKey: "Void",
                confirmMessage: VOID_CONFIRM_MESSAGE,
                requireVoidReason: true,
                hiddenWhenVoid: true,
                visibleWhenNotDraft: true,
                voidReasonLabel: "Void Reason",
                tooltip: "Void",
                Action: {
                  Module: "journal_voucher",
                  TransactionNoField: "voucher_no",
                },
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "journal_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "journal_voucher_summary",
              TableName: "vouchers",
              DisplayName: "vouchers",
              Query:
                "SELECT voucher_details.parent_id as id,vouchers.voucher_no,voucher_date,SUM(voucher_details.debit) total_debit,SUM(voucher_details.credit) total_credit,users.username,vouchers.narration,service_job_card.jobcard_no,vouchers.is_void,CASE WHEN COALESCE(vouchers.is_void,0)=1 THEN 'Void' ELSE '' END AS status FROM vouchers LEFT JOIN voucher_details ON voucher_details.parent_id=vouchers.id LEFT JOIN users ON users.id=vouchers.created_by LEFT JOIN service_job_card ON service_job_card.parent_id = vouchers.job_card_id WHERE voucher_type='Journal' AND COALESCE(vouchers.soft_delete,0)=0 AND vouchers.transaction_branch_id = '<branch_id>' GROUP BY voucher_details.parent_id,vouchers.voucher_no,voucher_date,users.username,vouchers.narration,service_job_card.jobcard_no,vouchers.is_void",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                VOID_STATUS_FIELD,
                {
                  IncludeLabel: true,
                  Label: "Voucher No.",
                  BindValue: "txt_voucher_no",
                  Json_Attribute: "voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher date",
                  IsMandatory: false,
                  BindValue: "txt_date",
                  Json_Attribute: "voucher_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard number",
                  BindValue: "txt_jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Total debit",
                  BindValue: "txt_est",
                  Json_Attribute: "total_debit",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Total credit",
                  BindValue: "txt_est",
                  Json_Attribute: "total_credit",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Narration",
                  BindValue: "txt_narration",
                  Json_Attribute: "narration",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "username",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
